var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{smallStar: _vm.type === 'small', largeStar: _vm.type == 'large'}},_vm._l((_vm.starArray),function(item,key){return _c('img',{key:key,attrs:{"src":item,"alt":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }